"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ICON = exports.ICON_CONTAINER = exports.BUTTON = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    BUTTON = (0, _cxs["default"])({
  color: _vars.COLOURS.grey.regent,
  minHeight: "85px"
});

exports.BUTTON = BUTTON;
var ICON_CONTAINER = (0, _cxs["default"])({
  display: "inline-flex",
  flexDirection: "column",
  alignItems: "center",
  " > p": {
    marginBottom: 0,
    marginTop: "5px"
  }
});
exports.ICON_CONTAINER = ICON_CONTAINER;
var ICON = (0, _cxs["default"])({
  cursor: "pointer",
  position: "relative",
  width: "50px",
  minWidth: "50px !important",
  minHeight: "50px !important",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  " > span": {
    position: "relative",
    zIndex: 1
  },
  ":hover": {
    background: _vars.COLOURS.grey.catSkillWhite
  }
});
exports.ICON = ICON;